import React from 'react'

import {
  StyledContainer,
  StyledBullets,
  StyledCheckboxWrapper,
  StyledTitle,
  StyledNumSelected
} from './Option.styles'

import Checkbox from '../checkbox/Checkbox'

import renderWithBoldSubstring from '../../../shared/utilities/react/renderWithBoldSubstring'

/**
 * <Option />
 *
 * This is what's rendered inside a tree node.
 * Decoupled from <Node> for reusablity.
 */
export default class Option extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      numSelected: -1,
      prevNumSelected: -1
    }
  }

  onClickCheckbox = status => {
    this.props.onClickCheckbox(this.props.path)
  }

  static getDerivedStateFromProps(props, state) {
    return props.isParent
      ? { numSelected: props.numSelected, prevNumSelected: state.numSelected }
      : null
  }

  render() {
    const { isParent } = this.props
    const { numSelected, prevNumSelected } = this.state

    const { title, searchTermIndex, searchTermLength } = this.props
    const displayTitle = (searchTermIndex > -1 && searchTermLength)
      ? renderWithBoldSubstring(title, searchTermIndex, searchTermLength)
      : title

    // Bullets are rendered as '·' (middot) characters, not SVG icons, for performance reasons
    const depth = this.props.path.length

    // Needs String.repeat polyfill:
    // const bullets = (depth > 1) && <StyledBullets>{'·'.repeat(depth - 1)}</StyledBullets>

    // Without String.repeat polyfill:
    let bulletsStr = ''

    for( let i = depth - 1; i--; ) bulletsStr += '·'
    const bullets = (depth > 1) && <StyledBullets>{bulletsStr}</StyledBullets>

    return (
      <StyledContainer isParent={isParent} title={title}>

        { bullets }

        <StyledCheckboxWrapper>
          <Checkbox status={this.props.checkboxStatus} onChange={this.onClickCheckbox} />
        </StyledCheckboxWrapper>

        <StyledTitle>
          { displayTitle }
        </StyledTitle>

        { (isParent && numSelected > 0) &&
          <StyledNumSelected anim={!this.props.isOpenAnimIn && prevNumSelected !== -1}>
            ({numSelected})
          </StyledNumSelected>
        }

      </StyledContainer>
    )
  }
}
